import React from 'react';
import { SearchUniversal } from '@duxton-web/icons';
import { Flex, Input } from '@duxton-web/ui';
import dayjs from 'dayjs';

import { FILTER_NOT_AVAILABLE_IN_CALENDAR_TEXT } from '../constants';
import FilterDrawer, {
  Filter,
} from '@/common/components/FilterDrawer/FilterDrawer';
import { EXPERIMENTS_VIEW } from '@/common/const';
import { FilterType } from '@/common/const/filterTypes';
import { SelectType } from '@/common/const/selectTypes';
import {
  AB,
  ABORTED,
  ADAPTIVE,
  CANCELLED,
  COMPLETED,
  REQUESTED,
  SCHEDULED,
  STARTED,
} from '@/constants';

export interface FilterState {
  dates?: [dayjs.Dayjs, dayjs.Dayjs];
  owner?: string[];
  state?: string[];
  experimentType?: string[];
  country?: string[];
  city?: string[];
  tags?: string[];
  variable?: string[];
  overlap?: boolean;
  manager?: string[];
  analyst?: string[];
  domain?: string[];
  backend?: string[];
}

const CALENDAR_FILTER_FIELDS: Filter[] = [
  {
    label: 'Date Range',
    name: 'dates',
    type: FilterType.DATE_RANGE,
    infoBannerText: FILTER_NOT_AVAILABLE_IN_CALENDAR_TEXT,
    disabled: true,
  },
  {
    label: 'Owner',
    name: 'owner',
    selectType: SelectType.USER,
    placeholder: 'Select owner',
  },
  {
    label: 'Status',
    name: 'state',
    options: [
      { label: 'Requested', value: REQUESTED },
      { label: 'Scheduled', value: SCHEDULED },
      { label: 'Running', value: STARTED },
      { label: 'Completed', value: COMPLETED },
      { label: 'Aborted', value: ABORTED },
      { label: 'Cancelled', value: CANCELLED },
    ],
    placeholder: 'Select status',
  },
  {
    name: 'experimentType',
    label: 'Type',
    options: [
      { label: 'A/B', value: AB },
      { label: 'Adaptive', value: ADAPTIVE },
    ],
    placeholder: 'Select type',
  },
  {
    name: 'country',
    label: 'Country',
    selectType: SelectType.COUNTRY,
    placeholder: 'Select country',
  },
  {
    name: 'city',
    label: 'City',
    selectType: SelectType.CITY,
    placeholder: 'Select city',
  },
  {
    name: 'tags',
    label: 'Tags',
    selectType: SelectType.TAG,
    placeholder: 'Select tag',
    infoBannerText: FILTER_NOT_AVAILABLE_IN_CALENDAR_TEXT,
    disabled: true,
  },
  {
    name: 'variable',
    label: 'Variable Included',
    selectType: SelectType.VARIABLE,
  },
  {
    name: 'overlap',
    label: 'Only show overlapping experiments',
    type: FilterType.BOOLEAN,
    infoBannerText: FILTER_NOT_AVAILABLE_IN_CALENDAR_TEXT,
    disabled: true,
  },
  {
    name: 'manager',
    label: 'Product Manager',
    selectType: SelectType.USER,
    placeholder: 'Select product manager',
  },
  {
    name: 'analyst',
    label: 'Product Analyst',
    selectType: SelectType.USER,
    placeholder: 'Select product analyst',
  },
  {
    name: 'domain',
    label: 'Domain',
    selectType: SelectType.DOMAIN,
    placeholder: 'Select domain',
  },
  {
    name: 'backend',
    label: 'Primary Service',
    selectType: SelectType.BACKEND,
    placeholder: 'Select primary service',
  },
];

interface CalendarFiltersProps {
  searchVal: string;
  onSearchChange: (value: string) => void;
  onSearch: (value: string) => void;
  filters: FilterState;
  onApplyFilter: (filters: FilterState) => void;
  rightActions?: React.ReactNode[];
}

export const CalendarFilters = ({
  searchVal,
  onSearchChange,
  onSearch,
  filters,
  onApplyFilter,
  rightActions = [],
}: CalendarFiltersProps) => {
  return (
    <Flex
      vertical={false}
      align="center"
      justify="space-between"
      style={{
        borderBottom: '1px solid #e8e8e8',
        marginBottom: 16,
        height: 64,
      }}
    >
      <Input.Search
        value={searchVal}
        style={{ width: 370, paddingLeft: 24 }}
        size="middle"
        placeholder="Search by name"
        enterButton={<SearchUniversal twoToneColor={'#FFF'} />}
        onSearch={onSearch}
        onChange={(e) => onSearchChange(e.target.value)}
      />
      <Flex gap={8} style={{ paddingRight: 16 }}>
        <FilterDrawer
          fields={CALENDAR_FILTER_FIELDS}
          ignoreFilters={[EXPERIMENTS_VIEW]}
          onApply={onApplyFilter}
          filters={filters}
        />
        {rightActions.map((component, index) => (
          <React.Fragment key={index}>{component}</React.Fragment>
        ))}
      </Flex>
    </Flex>
  );
};
